// Quoted email history in the thread (2026-10-13): the earlier turns an email
// quoted that CXHub does not otherwise hold (the server's
// messages.quoted_history, mapped as message.quotedHistory, oldest first).
// Each renders as an ordinary bubble of its direction, before the message
// that quoted it, with "from quoted email history" on its date line. The
// message itself still shows only its newest content. A message without any
// renders exactly as before.

export const QUOTED_HISTORY_NOTE = 'from quoted email history'

// The turns to show before this message, each with the direction its bubble
// takes (a sender we could not read shows as the customer's side).
export function quotedTurnsFor(message) {
  const turns = Array.isArray(message?.quotedHistory) ? message.quotedHistory : []
  return turns
    .filter((t) => t && (t.text || t.html))
    .map((t, i) => ({
      key: `${message.id}-quoted-${i}`,
      turn: t,
      direction: t.direction === 'outbound' ? 'outbound' : 'inbound',
    }))
}

// "Oct 8, 2026, 2:15 PM · From Jane Customer <jane@example.com> · from quoted
// email history"; the date and From are left out when unknown.
export function quotedTurnDateLine(turn, formatDate) {
  const parts = []
  if (turn?.sentAt) parts.push(formatDate(turn.sentAt))
  const name = turn?.senderName ?? null
  const address = turn?.senderAddress ?? null
  if (name || address) parts.push(`From ${name && address ? `${name} <${address}>` : (name ?? address)}`)
  parts.push(QUOTED_HISTORY_NOTE)
  return parts.join(' · ')
}
